import { IConnectContact } from './contact';

export interface IIncomingCall {
  contact: IConnectContact;
  roomName: string;
}

export enum ConnectDeclineReason {
  MANUAL = 'Manual',
  TIMEOUT = 'Timeout',
}
